import apiDefaultConfig from './coreApiDefaultConfig'
import { runCoreApiGetRequest, runCoreApiPostRequest } from '@/coreApi/coreApi'
import { getCurrentAccountData, getCurrentProjectData } from '@/auth/utils'

// Users
export function addUserSegment(data) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentUserAdd
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{segment_type}', 'user')}`
    return runCoreApiPostRequest(url, { user_data: data })
}

export function getUserSegments() {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentUsers
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)}`
    return runCoreApiGetRequest(url)
}

export function getUserSegmentDetails(segmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentUserDetails
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{segment_type}', 'user')
        .replace('{segment_id}', segmentId)}`
    return runCoreApiPostRequest(url)
}

export function editUserSegment(userSegmentId, data) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentUserEdit
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{segment_type}', 'user')
        .replace('{user_segment_id}', userSegmentId)}`
    return runCoreApiPostRequest(url, { user_data: data })
}

export function deleteUserSegment(userSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentUserDelete
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{user_segment_id}', userSegmentId)}`
    return runCoreApiPostRequest(url)
}

export function previewSegmentUser(userSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.previewUserSegment
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{user_segment_id}', userSegmentId)}`
    return runCoreApiPostRequest(url)
}

export function publishSegmentUser(userSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.publishUserSegment
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{user_segment_id}', userSegmentId)}`
    return runCoreApiPostRequest(url)
}

export function unPublishSegmentUser(userSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.unPublishUserSegment
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{user_segment_id}', userSegmentId)}`
    return runCoreApiPostRequest(url)
}

// Pages
export function addPageSegment(data) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentPageAdd
        .replace('{account_id}', account.accountId)
        .replace('{segment_type}', 'page')
        .replace('{project_id}', project.projectId)}`
    return runCoreApiPostRequest(url,{ page_data: data })
}

export function getPageSegments() {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentPages
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)}`
    return runCoreApiGetRequest(url)
}

export function getPageSegmentDetails(segmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentPageDetails
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{segment_type}', 'page')
        .replace('{segment_id}', segmentId)}`
    return runCoreApiPostRequest(url)
}

export function editPageSegment(pageSegmentId, data) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentPageEdit
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{segment_type}', 'page')
        .replace('{page_segment_id}', pageSegmentId)}`
    return runCoreApiPostRequest(url, { page_data: data })
}

export function deletePageSegment(pageSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentPageDelete
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{page_segment_id}', pageSegmentId)}`
    return runCoreApiPostRequest(url)
}


export function previewSegmentPage(pageSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.previewPageSegment
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{page_segment_id}', pageSegmentId)}`
    return runCoreApiPostRequest(url)
}

export function publishSegmentPage(pageSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.publishPageSegment
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{page_segment_id}', pageSegmentId)}`
    return runCoreApiPostRequest(url)
}

export function unPublishSegmentPage(pageSegmentId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.unPublishPageSegment
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{page_segment_id}', pageSegmentId)}`
    return runCoreApiPostRequest(url)
}

// Actions
export function addActionSegment(data) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentActionAdd
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{segment_type}', 'action')}`
    return runCoreApiPostRequest(url, { action_data: data })
}

export function getSegmentActions() {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentActions
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)}`
    return runCoreApiGetRequest(url)
}

export function getSegmentActionDetails(actionId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentActionDetails
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{action_id}', actionId)}`
    return runCoreApiGetRequest(url)
}

export function editSegmentAction(actionId, data) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentActionEdit
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{action_id}', actionId)}`
    return runCoreApiPostRequest(url, { action_data: data })
}

export function deleteSegmentAction(actionId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.segmentActionDelete
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{action_id}', actionId)}`
    return runCoreApiPostRequest(url)
}

export function publishAction(actionId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.publishSegmentAction
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{action_id}', actionId)}`
    return runCoreApiPostRequest(url)
}

export function unPublishAction(actionId) {
    const account = getCurrentAccountData()
    const project = getCurrentProjectData()
    const url = `${apiDefaultConfig.unPublishSegmentAction
        .replace('{account_id}', account.accountId)
        .replace('{project_id}', project.projectId)
        .replace('{action_id}', actionId)}`
    return runCoreApiPostRequest(url)
}
